import _ from "lodash";
import store from '@/store/index';

export class AccessControlCheck {
  static check(permission) {
    const user_permissions = AccessControlCheck.getUserPermissions();
    const permission_list = user_permissions
      ? typeof user_permissions === "string"
        ? user_permissions.split(",")
        : user_permissions
      : [];

    return !!permission_list.find(item => item === permission);
  }
  static checkPermission(permission) {
    if (permission) {
      return _.isArray(permission)
        ? permission.reduce((acc, cur) => {
          return acc && AccessControlCheck.check(cur)
        }, true)
        : AccessControlCheck.check(permission)
    }

    return true;
  }
  static checkRole(role) {
    if (role) {
      const  roles = AccessControlCheck.getUserRoles();
      role = _.isArray(role) ? role : [_.trim(_.toString(role))];

      return !!(role.length === 0 || _.intersection(roles, role).length);
    }
    return true;
  }
  static getUserRoles() {
    return _.split(store.getters.getAuthRoles, ',');
  }
  static getUserPermissions() {
    return store.getters.getAuthPermissions;
  }
}

